import React from 'react'
import { IProps } from './index'

// styles for background are added in src/styles/themes/background-themes.scss
export const Background = ({ theme, children }: IProps) => {
  return <div className={`background theme-${theme}`}>{children}</div>
}
